import { Skeleton } from "@/components/shared/Skeleton";

export function ClassroomCardSkeleton() {
  return (
    <div className="app-card flex flex-col gap-4 p-5">
      <div className="space-y-2">
        <Skeleton className="h-7 w-2/3" />
        <Skeleton className="h-6 w-28 rounded-full" />
      </div>
      <Skeleton className="h-8 w-full rounded-md" />
    </div>
  );
}
